export default __webpack_public_path__ + "static/media/mario5.9ea609cd.jpg";